'use client'

import PropTypes from 'prop-types'
import MUIButton from '@mui/material/Button'
import MUITypography from '@mui/material/Typography'
import MUICheckbox from '@mui/material/Checkbox'
import MUIStack from '@mui/material/Stack'
import MUIFormControlLabel from '@mui/material/FormControlLabel'
import { useState, useContext } from 'react'
import { useTheme } from '@mui/material/styles'
import { useUpcomingDatesStore } from '@repo/store/useUpcomingDatesStore'
import { ComingUpContext } from '@repo/dashboard/ComingUpContext'

export const ComingUpSettingsForm = ({ cancelAction }) => {
  const theme = useTheme()
  const mode = useContext(ComingUpContext)

  const { workspace, dashboard, setFilterOptions } = useUpcomingDatesStore()
  const settings = mode === 'workspace' ? workspace : dashboard

  const {
    IncludeMattersForReview,
    KeyDateAssignedToUser,
    KeyDateAddedByUser,
    KeyDateRedirectedToUser,
    KeyDatesForSupervisingFeeEarner
  } = settings

  const [assignedToMe, setAssignedToMe] = useState(KeyDateAssignedToUser)
  const [redirectedToMe, setRedirectedToMe] = useState(KeyDateRedirectedToUser)
  const [addedByMe, setAddedByMe] = useState(KeyDateAddedByUser)
  const [supervisingFeeEarner, setSupervisingFeeEarner] = useState(KeyDatesForSupervisingFeeEarner)

  const handleSubmit = (e) => {
    e.preventDefault()

    setFilterOptions({
      isMatterSpecific: mode === 'workspace',
      IncludeMattersForReview,
      KeyDateAddedByUser: addedByMe,
      KeyDateAssignedToUser: assignedToMe,
      KeyDateRedirectedToUser: redirectedToMe,
      KeyDatesForSupervisingFeeEarner: supervisingFeeEarner
    })

    cancelAction()
  }

  return (
    <>
      <form onSubmit={handleSubmit} data-testid="ComingUpSettingsForm">
        <hr
          style={{
            opacity: 0.12,
            borderColor: theme?.palette?.support?.navy || 'black',
            borderTop: 'none',
            marginBottom: '24px'
          }}
        />
        <MUIStack direction="column" gap={1}>
          <MUITypography variant="body1">When showing key dates, include items:</MUITypography>

          <MUIFormControlLabel
            sx={{ ml: 2 }}
            control={<MUICheckbox checked={assignedToMe} onChange={(e) => setAssignedToMe(e.target.checked)} />}
            label="Assigned to me"
          />

          <MUIFormControlLabel
            sx={{ ml: 2 }}
            control={<MUICheckbox checked={redirectedToMe} onChange={(e) => setRedirectedToMe(e.target.checked)} />}
            label="Redirected to me"
          />

          <MUIFormControlLabel
            sx={{ ml: 2 }}
            control={<MUICheckbox checked={addedByMe} onChange={(e) => setAddedByMe(e.target.checked)} />}
            label="Added by me"
          />

          <MUIFormControlLabel
            sx={{ ml: 2 }}
            control={
              <MUICheckbox checked={supervisingFeeEarner} onChange={(e) => setSupervisingFeeEarner(e.target.checked)} />
            }
            label="Where I’m the supervising Fee Earner"
          />
        </MUIStack>

        <MUIStack direction="row" justifyContent="flex-end" gap={1} sx={{ mt: 6, mb: 1 }}>
          <MUIButton variant="contained" color="text" onClick={cancelAction}>
            Cancel
          </MUIButton>
          <MUIButton variant="contained" color="primary" type="submit">
            Save
          </MUIButton>
        </MUIStack>
      </form>
    </>
  )
}

ComingUpSettingsForm.propTypes = {
  cancelAction: PropTypes.func
}
